<template>
  <div class="col-sm-3 col-xs-6">
    <div class="description-block border-right">
      <span :class="['description-percentage', obj.style]"><i :class="['fa' , obj.caret]"></i> {{obj.pct | currency('%')}}</span>
      <h5 class="description-header" v-if="type === 'qty'">
        {{current}}
      </h5>
      <h5 class="description-header" v-else>
        {{current | currency}}
      </h5>
      <span class="description-text">{{text | translate}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['text', 'current', 'previous', 'type'],
  data () {
    return {
      obj: {
        style: '',
        pct: '',
        caret: ''
      }
    }
  },
  methods: {
    calculatePct () {
      let pct = this.previous === 0 ? this.current * 100 : this.current * 100 / this.previous
      if (pct > 100) {
        this.obj.caret = 'fa fa-caret-up'
        this.obj.style = this.type === 'return' ? 'text-danger' : 'text-success'
        this.obj.pct = pct - 100
      } else if (pct === 100) {
        this.obj.caret = 'fa fa-caret-left'
        this.obj.style = 'text-warning'
        this.obj.pct = 0
      } else {
        this.obj.caret = 'fa fa-caret-down'
        this.obj.style = this.type === 'return' ? 'text-success' : 'text-danger'
        this.obj.pct = 100 - pct
      }
    }
  },
  mounted () {
    this.calculatePct()
  },
  watch: {
    current () {
      this.calculatePct()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/StatsDescriptionBox.vue